import _get from 'lodash/get';
import _set from 'lodash/set';
import { create } from 'mutative';
import { useCallback } from 'react';

export function useGetSSEMergeFunction({ updateSSEPath }: { updateSSEPath: string }) {
  const sseMergeFunction = useCallback(
    (oldData: unknown, newChunk?: unknown) => {
      // Initialize data if none exists
      if (!oldData) {
        return newChunk;
      }

      // Only process object data for streaming text accumulation
      if (typeof oldData !== 'object' || oldData === null) {
        return oldData;
      }

      // Handle the completion message
      if (_get(newChunk, 'completed') === true) {
        return oldData;
      }

      // Extract the new data chunk using the configurable path
      const newDataChunk = _get(newChunk, updateSSEPath, '');

      // Skip processing if no new chunk data
      if (!newDataChunk) {
        return oldData;
      }

      // Use mutative create for immutable updates
      return create(oldData, (draft) => {
        // Get current accumulated text using the same path
        const currentText = _get(draft, updateSSEPath, '');

        // Concatenate the new chunk and update the specific path
        const updatedText = currentText + newDataChunk;
        _set(draft, updateSSEPath, updatedText);
      });
    },
    [updateSSEPath],
  );

  return {
    sseMergeFunction,
  };
}
